import { type SearchCombinedConfigPayload } from '@atlassian/search-client/config';

import { type ConnectorRow } from '../thirdPartyPromptTypes.ts';

const isNullableString = (value: unknown): value is string | null | undefined =>
	value === undefined || value === null || typeof value === 'string';

// The payload type is what the schema promises. This is a stale cache another surface wrote.
const isConnectorRow = (value: unknown): value is ConnectorRow => {
	if (typeof value !== 'object' || value === null) {
		return false;
	}

	const row = value as Record<string, unknown>;

	return (
		typeof row.name === 'string' &&
		typeof row.isUserOAuthed === 'boolean' &&
		isNullableString(row.outboundAuthUrl) &&
		isNullableString(row.providerId) &&
		isNullableString(row.connectorSyncType)
	);
};

/** Raw rows, never the merged `thirdPartyConfigs`, which hides the Smart Links grant. */
export const readConnectorRows = (payload: SearchCombinedConfigPayload): ConnectorRow[] => {
	const rows: unknown = payload.thirdPartyProducts;

	return Array.isArray(rows) ? rows.filter(isConnectorRow) : [];
};
